import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnswerBehavior, Question } from 'src/app/core/models/questionnaire.model';
import { AgentClientsService } from 'src/app/core/services/agent-clients.service';
import { QuestionAnswer } from '../question/question.component';

@Component({
  selector: 'app-question-select',
  templateUrl: './question-select.component.html',
  styleUrls: ['./question-select.component.scss'],
})
export class QuestionSelectComponent implements OnInit {
  @Input('question') question!: Question;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();

  blockMessage: string | null = null;

  constructor(private agentClientsService: AgentClientsService) {}

  ngOnInit(): void {
    this.change();
  }

  change() {
    setTimeout(() => {
      this.evaluateAnswerBehavior();
      this.changeAnswer.next({
        answer: this.question.answer!,
        question: this.question,
      });
    }, 10);
  }

  private evaluateAnswerBehavior(): void {
    const behaviors: AnswerBehavior[] | undefined =
      this.question.configuration?.answer_behavior;
    if (!behaviors?.length) {
      this.blockMessage = null;
      return;
    }

    const isAgent = this.agentClientsService.isAgentSession();
    const selectedValue = this.question.answer?.value;

    const matched = behaviors.find(
      (b) => b.agent === isAgent && b.answerValue === selectedValue
    );

    if (matched?.block) {
      this.blockMessage = matched.message;
      this.question.isValid = false;
      this.question.messageError = matched.message;
      this.question.isBlockedByAnswerBehavior = true;
    } else {
      this.blockMessage = null;
      this.question.isValid = true;
      this.question.messageError = undefined;
      this.question.isBlockedByAnswerBehavior = false;
    }
  }
}
